<router-outlet #outlet="outlet"></router-outlet>
<ng-container *ngIf="!outlet.isActivated">
  <app-super-admin-header workspaceRoute="/home/main/dashboard"
    insightsRoute="/home/main/insights"></app-super-admin-header>
  <div class="asset-team-container">
    <app-asset-info [title]="'Workspace'" [assets]="workspaceList" [title]="'Workspace Status'"
      (createWorkspaceClicked)="createWorkspace()" (workspaceStatus)="handleStatus($event)"></app-asset-info>
    <div class="divider-container">
      <div class="divider"></div>
    </div>
    <div class="dash-section-wrapper container-with-no-border" [ngClass]="{ loader: loaderView }">
      <div *ngIf="loaderView">
        <app-loader></app-loader>
      </div>
      <div>
        <app-table [tableConfig]="tableConfig" [tableData]="tableDetails" [searchOptions]="REQUEST_SEARCH_OPTIONS"
          (searchData)="search($event)" (activeFilter)="filterTickets($event)" [count]="count"
          (paginatorEmitter)="getAllTickets($event)" [filterOptions]="PAGINATION_DATA"
          (pageSizeChange)="pageSizeChange($event)" [activeMenu]="pageSize" class="width-100" [fieldArray]="fieldArray!"
          [tableDetails]="tableDetails" (tableNavigationClick)="navigateToWorkspace($event)"
          (onSort)="handleSortAction($event)"></app-table>
      </div>
    </div>
  </div>
</ng-container>